import history from 'utils/browserHistory';

export function init() {
  history.push('/analytics/dashboards');
}
